import { ROUTES } from './routes'
import type { IRules } from '../../interfaces/src/speculation-rules.interface'

export const DEFAULT_APPS_RULES: IRules[] = [
  {
    urls: [
      ROUTES.HOME,
      ROUTES.MY_PROPERTIES,
      ROUTES.SEARCH,
      ROUTES.LEAD_MANAGEMENT,
      ROUTES.APPRAISALS(),
      ROUTES.ACCOUNT_PROFILE
    ],
    eagerness: 'immediate'
  },
  {
    urls: [
      ROUTES.MANAGE_PLATFORMS,
      ROUTES.LISTS,
      ROUTES.SHOP,
      ROUTES.NEW_PROFILE,
      ROUTES.AGENCY_SITE
    ],
    eagerness: 'moderate'
  }
]

export const DEFAULT_ASSOCIATION_RULES: IRules[] = [
  {
    urls: [
      ROUTES.ASSOCIATION_AGENCIES,
      ROUTES.ASSOCIATION_BROKERS,
      ROUTES.ASSOCIATION_PROPERTIES,
      ROUTES.ASSOCIATION_REPORTS
    ],
    eagerness: 'immediate'
  },
  {
    urls: [ROUTES.SHOP, ROUTES.AGENCY_SITE],
    eagerness: 'moderate'
  }
]

export const DEFAULT_DEVELOPMENT_AGENT_RULES: IRules[] = [
  {
    urls: [ROUTES.COMPA_LENDING],
    eagerness: 'immediate'
  }
]
